// extracted by mini-css-extract-plugin
export var completionBody = "_jd-2";
export var completionCard = "_jd-0";
export var completionFooter = "_jd-3";
export var completionTitle = "_jd-1";